import getConfigTID from "@/lib/getConfigTID"

/**
 * Opens the Trimble Identity (TID) OAuth authorize flow for a standard
 * "Sign in" control, returning the user to the current page after login.
 *
 * Client-only (reads `window.location`) — mirrors the queryString + return
 * path pattern used by `useAuthCheck`'s silent SSO check and
 * `useFlyoutCart`'s cart sign-in, just without the `&prompt=none`/checkout
 * bits those flows add.
 */
export function handleTIDSignIn(): void {
  const { queryString } = getConfigTID()
  const returnPath = encodeURIComponent(
    `${window.location.origin}${window.location.pathname}`,
  )
  window.open(`${queryString}${returnPath}`, "_self")
}
